import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {DTFService} from '../../dtf.service';
import { Banner } from '../../shared/models/banner';
import { throwError } from 'rxjs';



@Injectable({ providedIn: 'root' })

export class DTFHomepageService {

    constructor(private http: HttpClient, private dtfService: DTFService) {}

    // getBanners(): Observable<Array<Banner>> {
    //     return this.http.get<Array<Banner>>(this.dtfService.getBannersUrl(),
    //         {headers: this.dtfService.getHttpHeaders()});
    // }

  getCaptcha(): Observable<boolean> {
      return this.http.get<boolean>(this.dtfService.getCaptcha(), { headers: this.dtfService.getHttpHeaders()});
  }
  getAlerts(): Observable<Array<Banner>> {
        return this.http.get<Array<Banner>>(this.dtfService.getAlerts(),
            {headers: this.dtfService.getHttpHeaders()});
  }
  getAlertsAdmin(): Observable<Array<Banner>> {
        return this.http.get<Array<Banner>>(this.dtfService.getAlertsAdmin(),
            {headers: this.dtfService.getHttpHeaders()});
  }
  PayToggle(): Observable<Array<Banner>> {
        return this.http.get<Array<Banner>>(this.dtfService.PayToggle(),
            {headers: this.dtfService.getHttpHeaders()});
  }
  getCIAMUserDetails(request: any) {
     return this.http.post<any>(this.dtfService.getUserDetailsFromCodeUrl(), request, { headers: this.dtfService.getHttpHeaders() });
  }
  registerProfile(request: any) {
      return this.http.post<any>(this.dtfService.registerProfile(), request, { headers: this.dtfService.getHttpHeaders() });
  }
    startSession(request: any) {
      return this.http.post<any>(this.dtfService.startSession(), request, { headers: this.dtfService.getHttpHeaders() });
  }
    insertUser(request: any) {
    return this.http.post<any>(this.dtfService.insertUser(), request, { headers: this.dtfService.getHttpHeaders() });
}

      private handleError(error: HttpErrorResponse) {
        if (error.status === 404) {
      return throwError(() => 'We could not find anything matching with the requested resource.');
        }
      return throwError(() => error.error.message || 'Your request cannot be processed. Please try again later.');
      }
}
